module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('question-editor', {
    attrs: {
      "value": {
        title: 'Mobile Number',
        questionType: 'TEXT'
      },
      "is-static": true
    }
  }), _vm._v(" "), _c('draggable', {
    staticClass: "question-container",
    class: {
      empty: _vm.isEmpty
    },
    attrs: {
      "draggable": ".draggable",
      "group": "questions",
      "handle": ".header",
      "ghost-class": "question-ghost"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.questionList),
      callback: function($$v) {
        _vm.questionList = $$v
      },
      expression: "questionList"
    }
  }, [_vm._l((_vm.questionList), function(question, index) {
    return _c('div', {
      key: question.id,
      staticClass: "item",
      class: {
        draggable: _vm.isEditable
      }
    }, [_c('question-editor', {
      attrs: {
        "value": _vm.questionList[index],
        "index": index + 1,
        "is-selected": question.id === _vm.canvasSelectedQuestionId,
        "isEditable": _vm.isEditable
      },
      on: {
        "input": function($event) {
          return _vm.handleSetQuestion(index, $event)
        },
        "onSelect": function($event) {
          return _vm.handleSelectQuestion(question.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemoveQuestion(index)
        },
        "onEdit": function($event) {
          return _vm.handleEditQuestion(question)
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n        Drag or double-click a qualitative question here from the qualitative questions panel on the right, or \n        "), _c('a', {
    on: {
      "click": _vm.handleCreateQuestion
    }
  }, [_vm._v("Create qualitative question")])])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07319212","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/QuestionCanvas.vue
// module id = 3123
// module chunks = 3